import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import TheFullCatalog from "./sections/TheFullCatalog";
import WorkWithUs from "./sections/WorkWithUs";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <TheFullCatalog />
      <WorkWithUs />
      <Footer />
    </div>;
}